import { cdnImage } from "@/lib/imageCdn";
import { inlineImageAlt, type ArticleImage } from "@/lib/blogArticleQueries";

/** Place media between complete sections, reserving a small corner inside each banner for the logo. */
export function articleInlineMedia(content: string, images: ArticleImage[], title: string, language: "en" | "el", logoUrl: string): string {
  if (!images.length) return content;
  const isHTML = /<(h[1-6]|p|ul|ol|div|blockquote|figure)\b/i.test(content);
  let sections = isHTML ? content.split(/(?=<h2\b)/i) : content.split(/(?=^## )/m);
  if (sections.length < images.length + 1) sections = isHTML
    ? content.split(/(?<=<\/(?:p|ul|ol|blockquote|section|figure)>)\s*/i)
    : content.split(/\n\n+/);
  sections = sections.filter(s => s.trim());
  const words = (s: string) => s.replace(/<[^>]*>/g, " ").split(/\s+/).filter(Boolean).length;
  const total = sections.reduce((sum, s) => sum + words(s), 0);
  const esc = (v: string) => v.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  let count = 0;
  let index = 0;
  const out: string[] = [];
  const addImage = () => {
    const image = images[index];
    const alt = esc(inlineImageAlt(image.prompt, title, index, image.image_type, language));
    out.push(`<figure class="my-12 mx-auto max-w-4xl overflow-hidden rounded-[18px] border border-border" style="position:relative;background:#0c140f;padding-bottom:36px;">` +
      `<img src="${esc(cdnImage(image.image_url,1200))}" alt="${alt}" class="w-full h-auto" style="display:block;margin:0;" loading="lazy" decoding="async" width="1200" height="675" />` +
      `<img src="${esc(logoUrl)}" alt="EyeCaptain" width="104" height="26" style="position:absolute;right:16px;bottom:8px;height:20px;width:auto;margin:0;" loading="lazy" />` + `</figure>`);
    index++;
  };
  sections.forEach((section, i) => {
    out.push(section);
    count += words(section);
    const slotsLeft = sections.length - i - 1;
    if (slotsLeft > 0 && index < images.length && (count >= total * (index + 1) / (images.length + 1) || slotsLeft <= images.length - index)) addImage();
  });
  while (index < images.length) addImage();
  return out.join(isHTML ? "\n" : "\n\n");
}
